import { composeValidators, requiredValidation } from 'validators';
import { isDuplicateTemplateName } from './selectors';
export const MAX_TEMPLATE_NAME_LENGTH = 80;
export const templateNameValidation = (param)=>{
    let { t, existingTemplates, excludeTemplateId } = param;
    return composeValidators([
        requiredValidation(t.fieldRequired()),
        {
            validate: {
                tooLong: (value)=>typeof value !== 'string' || value.length <= MAX_TEMPLATE_NAME_LENGTH || t.nameTooLongError(),
                duplicate: (value)=>typeof value !== 'string' || !isDuplicateTemplateName(value, existingTemplates, excludeTemplateId) || t.duplicateNameMessage()
            }
        }
    ]);
};
